import { Link } from 'react-router-dom';
import LoadingSpinner from '../common/LoadingSpinner';

const FALLBACK_DASH = '—';

const todayYmd = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const resolveMovStartDate = (mov) => {
  const isoDate = mov?.created_at;
  if (typeof isoDate === 'string' && /^\d{4}-\d{2}-\d{2}/.test(isoDate)) {
    return isoDate.slice(0, 10);
  }

  const formattedDate = mov?.created_at_formatada;
  const match = typeof formattedDate === 'string'
    ? formattedDate.match(/^(\d{2})\/(\d{2})\/(\d{4})/)
    : null;

  if (match) {
    return `${match[3]}-${match[2]}-${match[1]}`;
  }

  return todayYmd();
};

const resolveSearchName = (adolescente) =>
  adolescente?.nome_adolescente
  || adolescente?.nome_social
  || adolescente?.nome
  || '';

function MovimentacoesGrid({
  loading = false,
  error = null,
  movimentacoes = [],
  pagination = null,
  currentPage = 1,
  onPageChange = null,
  adolescente = null,
  showNovaButton = false,
  loadingText = 'Carregando movimentações...',
  emptyText = 'Nenhuma movimentação encontrada.',
}) {
  const adolescenteId = adolescente?.id;
  const dashboardQueryName = resolveSearchName(adolescente);
  const iniciarNovaMovimentacaoLabel = 'Iniciar Nova Movimentação';
  const mostrarBotaoNovaMovimentacao = Boolean(showNovaButton && adolescenteId);

  return (
    <>
      {loading && <LoadingSpinner text={loadingText} />}
      {error && <div className="alert alert-danger">{error}</div>}

      {!loading && !error && (
        <>
          {movimentacoes.length === 0 ? (
            <div className="text-center text-secondary">
              {emptyText}
              {mostrarBotaoNovaMovimentacao && (
                <p style={{ marginTop: '1rem' }}>
                  <Link
                    to={`/painel/adolescentes/${adolescenteId}/movimentacoes/novo`}
                    className="btn btn-sm btn-outline-success"
                    title={iniciarNovaMovimentacaoLabel}
                  >
                    <i className="bi bi-play-circle"></i> {iniciarNovaMovimentacaoLabel}
                  </Link>
                </p>
              )}
            </div>
          ) : (
            <>
              <div className="table-responsive modal-table-box">
              <table className="table table-hover mb-0 lista_movimentacoes">
                <thead>
                  <tr>
                    <th>Início</th>
                    <th>Meio de Entrada</th>
                    <th>Situação Atual</th>
                    <th>Status</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {movimentacoes.map((mov) => (
                    <tr key={mov.id}>
                      <td>{mov.created_at_formatada || FALLBACK_DASH}</td>
                      <td>{mov.meio_entrada?.nome || FALLBACK_DASH}</td>
                      <td>{mov.situacao_atual?.nome || FALLBACK_DASH}</td>
                      <td>
                        {mov.finalizada ? (
                          <span className="badge bg-success">Finalizada</span>
                        ) : (
                          <span className="badge bg-warning text-dark">Em aberto</span>
                        )}
                      </td>
                      <td className="text-end d-flex gap-2 justify-content-end">
                        <Link
                          to="/painel/dashboard"
                          state={{
                            dashboardContext: {
                              date: resolveMovStartDate(mov),
                              status: 'all',
                              q: dashboardQueryName,
                            },
                          }}
                          className="btn btn-sm btn-outline-success"
                          title="Abrir Movimentação no Painel"
                        >
                          Visualizar
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
              {mostrarBotaoNovaMovimentacao && (
              <div className="text-center mt-3">
                <Link
                  to={`/painel/adolescentes/${adolescenteId}/movimentacoes/novo`}
                  className="btn btn-sm btn-outline-success"
                  title={iniciarNovaMovimentacaoLabel}
                >
                  <i className="bi bi-play-circle"></i> {iniciarNovaMovimentacaoLabel}
                </Link>
              </div>
            )}
            </>
          )}

          {pagination && pagination.last_page > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-3">
              <span>
                Página <strong>{pagination.current_page}</strong> de{' '}
                <strong>{pagination.last_page}</strong>
              </span>
              <div className="btn-group">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => onPageChange?.(currentPage - 1)}
                  disabled={currentPage === 1 || loading}
                >
                  <i className="bi bi-chevron-left"></i> Anterior
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => onPageChange?.(currentPage + 1)}
                  disabled={currentPage === pagination.last_page || loading}
                >
                  Próximo <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default MovimentacoesGrid;
